import classNames from 'classnames'
import CustomSelectInput from 'client/components/common/CustomSelect'
import { cls } from 'client/components/MyAccount/views/InvoiceEstimateSettings/ColumnsSettings'
import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Result } from 'client/Global/AnalyticsEvents'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import * as React from 'react'

export const colorAreas = ['dividers', 'total', 'columnHeaders', 'header'] as const

export const ColoredAreasDropdown = ({ settings, setSettings, changedValues, setChangedValues }) => {
  const areas = settings.settings.areas
  const isSelected = (area) => {
    return areas.includes(area)
  }

  const handleClick = (area: string) => {
    Segment.track(SegmentEvents.invoiceCustomise.invoiceCustomised, { invoice_coloured_elements_changed: area })
    const newAreas = isSelected(area) ? areas.filter((a) => a !== area) : areas.concat(area.toString())
    setSettings({
      loaded: true,
      modified: true,
      customSettings: {
        ...settings,
        settings: {
          ...settings.settings,
          areas: newAreas,
        },
      },
    })
    setChangedValues({
      ...changedValues,
      areas: true,
    })
    Analytics.trackEvent(Events.selectColoredAreas, {
      type: AnalyticsType.action,
      category: Category.setting,
      result: Result.success,
      placement: checkPlacement(window.location.pathname),
      area,
      status: isSelected(area) ? 'deselected' : 'selected',
    })
  }

  const getColoredAreasValue = () => {
    const value = areas.map((a) => l(`customTemplates.coloredAreas.${a}`)).join(', ')
    return value || l('customTemplates.coloredAreas.')
  }

  return (
    <CustomSelectInput
      className={'CustomTemplate'}
      label={l('customTemplates.coloredAreas')}
      value={getColoredAreasValue()}
      openDirection={'down'}
    >
      <ul className={cls('__list')}>
        {colorAreas.map((area, index) => {
          return (
            <li
              key={index}
              className={classNames(cls('__option'), { [cls('__option--selected')]: isSelected(area) })}
              onClick={() => handleClick(area)}
            >
              {l(`customTemplates.coloredAreas.${area}`)}
            </li>
          )
        })}
      </ul>
    </CustomSelectInput>
  )
}
